import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Tv = createReactComponent("Tv", ["svg", defaultAttributes, [["rect", {
  x: "2",
  y: "7",
  width: "20",
  height: "15",
  rx: "2",
  ry: "2",
  key: "1yx64j"
}], ["polyline", {
  points: "17 2 12 7 7 2",
  key: "1dznhz"
}]]]);
export default Tv;